export default function isRole(roles, user) {
  const userRoles = user?.roles ?? []
  return roles.some(item => userRoles.includes(item));
}